import { render, staticRenderFns } from "./GoalOverview.vue?vue&type=template&id=c41d7130&scoped=true&"
import script from "./GoalOverview.vue?vue&type=script&lang=js&"
export * from "./GoalOverview.vue?vue&type=script&lang=js&"
import style0 from "./GoalOverview.vue?vue&type=style&index=0&id=c41d7130&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41d7130",
  null
  
)

/* custom blocks */
import block0 from "./GoalOverview.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c41d7130')) {
      api.createRecord('c41d7130', component.options)
    } else {
      api.reload('c41d7130', component.options)
    }
    module.hot.accept("./GoalOverview.vue?vue&type=template&id=c41d7130&scoped=true&", function () {
      api.rerender('c41d7130', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/goal/GoalOverview.vue"
export default component.exports